export default __webpack_public_path__ + "static/media/txt2_sp.e5592c96.png";